import { Frame, FrameLoader, FrameTarget } from '@studiometa/ui';
import FrameForm from './FrameForm.js';

/**
 * @typedef {{}} ListingProps
 */

/**
 * Listing Listing.
 * @augments {Base<ListingProps>}
 */
export default class Listing extends Frame {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Listing',
    components: {
      FrameForm,
      FrameTarget,
      FrameLoader,
    },
    options: {
      ...Frame.config.options,
    },
  };
}
